import ProfileCompletion from './ProfileCompletion';

export default ProfileCompletion;
